import { InternalMessageBusChannels } from "sb-internal-msg-bus";
var ToggleTabEvent = /** @class */ (function () {
    function ToggleTabEvent(messageBus, blockId) {
        var _this = this;
        this.reset = function () { return _this.hasData = true; };
        this.messageBus = messageBus;
        this.blockId = blockId;
        this.hasData = true;
    }
    ToggleTabEvent.prototype.emit = function (elements, parentBlockId) {
        var hasData = elements.length > 0;
        if (this.hasData !== hasData) {
            this.hasData = hasData;
            this.messageBus.emit(InternalMessageBusChannels.legacy.tabSwitcher.showHideTab, !hasData, parentBlockId, this.blockId);
        }
    };
    return ToggleTabEvent;
}());
export { ToggleTabEvent };
//# sourceMappingURL=ToggleTabEvent.js.map